import {observer} from 'mobx-react';
import React from 'react';
import {ReactNodeGenerator} from '../../../../../../lib/helpers';
import {GapFillingEditStore} from '../GapFillingEditStore';

function AddGapControl(props: { store: GapFillingEditStore, index: number }) {
  const {store, index} = props;
  return (
    <div className="row justify-content-end">
      <div className="col-auto">
        <button type="button" className="btn btn-outline-primary"
                onClick={() => store.addGapStore(index)}>
          Add gap
        </button>
      </div>
    </div>);
}

function* renderer(store: GapFillingEditStore): ReactNodeGenerator {
  const hasExtra = store.hasExtraGapStores;
  const hasMissing = store.hasMissingGapStores;

  for (let i = 0; i < store.gaps.length; i++) {
    const first = i === 0;
    const last = i === store.gaps.length - 1;
    const gap = store.gaps[i];

    if (hasMissing)
      yield <AddGapControl store={store}
                           index={i}
                           key={'add-gap-' + i}/>;

    const value = gap.value;
    const placeholder = gap.placeholder;

    yield (
      <div className="row" key={i}>
        <div className="col">
          <div className="form-group">
            <label>Value</label>
            <input type="text" className="form-control"
                   value={value.value} onChange={value.onChangeHandler}/>
          </div>
        </div>
        <div className="col">
          <div className="form-group">
            <label>Placeholder</label>
            <input type="text" className="form-control"
                   value={placeholder.value} onChange={placeholder.onChangeHandler}/>
          </div>
        </div>
        <div className="col-auto">
          <button type="button" className="btn btn-primary"
                  disabled={first}
                  onClick={() => store.swapUp(i)}>
            <span className="fas fa-angle-double-up"/>
          </button>
          <button type="button" className="btn btn-primary"
                  disabled={last}
                  onClick={() => store.swapDown(i)}>
            <span className="fas fa-angle-double-down"/>
          </button>
          {
            hasExtra &&
            <button type="button" className="btn btn-outline-primary"
                    onClick={() => store.removeGapStore(i)}>
              <span className="fas fa-times"/>
            </button>
          }
        </div>
      </div>
    );
  }

  if (hasMissing)
    yield <AddGapControl store={store}
                         index={store.gaps.length}
                         key={'add-gap-' + store.gaps.length}/>;

  if (hasMissing)
    yield (
      <div className="row" key="missing">
        <div className="col">
          <div className="alert alert-danger">
            Missing {store.gapCountFromSerialized - store.gaps.length} gaps.
          </div>
        </div>
      </div>);

  if (hasExtra)
    yield (
      <div className="row" key="extra">
        <div className="col">
          <div className="alert alert-danger">
            Extra {store.gaps.length - store.gapCountFromSerialized} gaps.
          </div>
        </div>
      </div>);

}

@observer
export class GapSpecifications extends React.Component<{ store: GapFillingEditStore }> {
  render() {
    return Array.from(renderer(this.props.store));
  }
}
